module.exports = __webpack_public_path__ + "static/media/8.a5f7e0b0.png";